import { action } from 'satcheljs';

export const fetchProfileAction = action('fetchProfileAction');
